import styled from "styled-components";

export const MainContainer = styled.div`
  max-width: 1140px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
`;
